export default "//yastatic.net/s3/distribution/pythia/frontend/_/4197026df0284a8ba01dbac67dd9f948.png";